<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="mt-4 flex justify-center gap-4">
            <div class="text-black">{{ $t("vouchers.printing_batch") }}</div>
            <div>{{ batch_name }}</div>
            <div class="text-black">{{ $t("vouchers.count") }}</div>
            <div>{{ batch_count }}</div>
          </div>
          <div class="mt-4 flex justify-center">
            <div>
              <button
                class="btn btn-primary  waves-effect waves-light"
                tabindex="0"
                type="button"
                @click="printVouchers"
              >
                <span>
                  <i class="ti ti-printer ti-s me-md-2"></i>
                  <span class="d-md-inline-block d-none">{{
                    $t("actions.print")
                  }}</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="vouchers_print" class="noScreen">
      <div
        v-for="(page, pageIndex) in voucherPages"
        :key="pageIndex"
        class="voucher-print"
        :class="{ 'last-page': pageIndex === voucherPages.length - 1 }"
      >
        <div
          v-for="(voucher, index) in page"
          :key="voucher.id"
          class="voucher-ticket"
        >
          <div class="ticket-header">
            <span>{{ voucher.voucher_batch.name }}</span>
            <span
              >{{ voucher.voucher_batch.currency }} {{ voucher.amount }}</span
            >
          </div>

          <div class="ticket-body">
            <div class="ticket-label">
              {{ settings.network_name }}
            </div>
            <div class="ticket-label">
              {{ $t("vouchers.accounts_application_credits_charge") }}
            </div>
            <div class="ticket-label">
              Super Speed Radius
            </div>

            <div class="ticket-code">
              {{ voucher.code }}
            </div>

            <div class="ticket-validity" v-if="voucher.valid_before">
              {{ $t("vouchers.valid_before") }}
              {{ voucher.valid_before }}
            </div>
          </div>

          <div class="ticket-footer">
            <span>#{{ voucher.id }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { print_element } from "../global_constants.js";
import { mapGetters } from "vuex";
export default {
  name: "VouchersPrint",
  data() {
    return {
      vouchers: [],
      batch_name: "",
      batch_count: 0,
    };
  },
  async created() {
    await this.fetchCards();
  },
  computed: {
    ...mapGetters(["settings"]),
    voucherPages() {
      const pageSize = 24;
      const pages = [];

      for (let i = 0; i < this.vouchers.length; i += pageSize) {
        pages.push(this.vouchers.slice(i, i + pageSize));
      }

      return pages;
    },
  },
  methods: {
    async fetchCards() {
      this.loading = true;
      var requestString = "vouchers?rows=999999&filters=1";
      if (this.$route.params.id != null)
        requestString += `&voucher_batch_id=${this.$route.params.id}`;

      const response = await axios.get(requestString);
      if (response.status == 200) {
        this.vouchers = response.data.data;
        if (this.vouchers.length > 0) {
          this.batch_count = this.vouchers.length;
          this.batch_name = this.vouchers[0].voucher_batch.name;
        }
      }
    },
    print_element(id) {
      print_element(id);
    },
    async printVouchers() {
      await this.$nextTick();
      await this.print_element2("vouchers_print");
    },

    async print_element2(id) {
      const element = document.getElementById(id);

      if (!element) {
        console.error(`Print element not found: ${id}`);
        return;
      }

      const prtHtml = element.innerHTML;

      const page = `<!DOCTYPE html>
<html lang="ar" dir="rtl">
<head>
    <meta charset="UTF-8">
    <title>Vouchers ${this.$route.params.id}</title>

    <style>
        @page {
            size: A4 portrait;
            margin: 5mm;
        }

        * {
            box-sizing: border-box;
        }

        html, body {
            margin: 0;
            padding: 0;
            background: white;
            font-family: Arial, sans-serif;
            color: black;
        }

.voucher-print {
    width: 200mm;
    height: 287mm;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: repeat(6, minmax(0, 1fr));
    gap: 1mm;
    box-sizing: border-box;
    break-after: page;
    page-break-after: always;
}
    .voucher-print.last-page {
    break-after: auto;
    page-break-after: auto;
}

.voucher-ticket {
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px dashed #777;
}

        .ticket-header {
            display: flex;
            justify-content: space-between;
            gap: 1mm;
            font-size: 8pt;
            font-weight: bold;
        }

        .ticket-header span {
            min-width: 0;
            overflow-wrap: anywhere;
        }

        .ticket-body {
            text-align: center;
            margin: 1mm 0;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center; 
            justify-content: center;
        }

        .ticket-label {
            font-size: 8pt;
            margin-bottom: 2mm;
        }

        .ticket-code {
            font-size: 12pt;
            font-weight: bold;
            overflow-wrap: anywhere;
            margin-bottom: 2mm;
        }

        .ticket-username,
        .ticket-validity {
            font-size: 7pt;
            overflow-wrap: anywhere;
            margin-top: 1mm;
        }

        .ticket-footer {
            display: flex;
            justify-content: space-between;
            gap: 1mm;
            font-size: 7pt;
            border-top: 1px solid #ccc;
            padding-top: 1mm;
        }

       @media print {
    .voucher-print {
        width: 200mm;
        height: 287mm;
        break-after: page;
        page-break-after: always;
    }

    .voucher-print.last-page {
        break-after: auto;
        page-break-after: auto;
    }
}
    </style>
</head>
<body>
    ${prtHtml}

    <script>
        window.onload = function () {
            window.focus();
            setTimeout(function () {
                window.print();
            }, 300);
        };

        window.onafterprint = function () {
            window.close();
        };
    <\/script>
</body>
</html>`;

      const WinPrint = window.open("", "_blank", "width=900,height=900");

      if (!WinPrint) {
        alert("Please allow pop-ups to print vouchers.");
        return;
      }

      WinPrint.document.open();
      WinPrint.document.write(page);
      WinPrint.document.close();
    },
  },
};
</script>
<style scoped>
/* A4 paper: 210 × 297 mm */
@page {
  size: A4 portrait;
  margin: 5mm;
}

.voucher-print {
  width: 200mm;
  height: 287mm;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 1mm;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  color: #000;
}

.voucher-ticket {
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  border: 1px dashed #777;
  padding: 2mm;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  break-inside: avoid;
  page-break-inside: avoid;
}

.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1mm;
  font-size: 8pt;
  font-weight: bold;
}

.ticket-header span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.ticket-body {
  text-align: center;
  margin: 1mm 0;
}

.ticket-label {
  font-size: 8pt;
  margin-bottom: 2mm;
}

.ticket-code {
  font-size: 12pt;
  font-weight: bold;
  letter-spacing: 0.5px;
  overflow-wrap: anywhere;
  margin-bottom: 2mm;
}

.ticket-username,
.ticket-validity {
  font-size: 7pt;
  overflow-wrap: anywhere;
  margin-top: 1mm;
}

.ticket-footer {
  display: flex;
  justify-content: space-between;
  gap: 1mm;
  font-size: 7pt;
  border-top: 1px solid #ccc;
  padding-top: 1mm;
}

.ticket-footer span {
  min-width: 0;
  overflow-wrap: anywhere;
}

/* Hide everything except tickets when printing */
@media print {
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  body * {
    visibility: hidden;
  }

  .voucher-print,
  .voucher-print * {
    visibility: visible;
  }

  .voucher-print {
    position: absolute;
    left: 0;
    top: 0;
    width: 200mm;
    height: 287mm;
    margin: 0;
    padding: 0;
    gap: 1mm;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  .voucher-ticket {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>
